
      <div class="ui-g-12 sf-field-container">
        <div class="ui-g-12 ui-md-4">
          <span class="label" [attr.for]="id" [ngClass]="{'required': -1!==(formProperty.parent.schema.required||[]).indexOf(formProperty.path.split('/').slice(-1)[0])}">
            {{ schema.description }}
          </span>
        </div>
        <div class="ui-g-12 ui-md-8">
          <textarea
            pInputTextarea
            rows="10"
            class="notes-input"
            cols="60"
            [formControl]="control"
            [readonly]="schema.readOnly||false">
          </textarea>
        </div>
      </div>
  


// WEBPACK FOOTER //
// ./src/app/views/administration/apps-config/json-schema-form/custom-widgets/textarea.widget.ts.TextareaWidget.html